module.exports = __webpack_public_path__ + "img/museopatagonia.bcb08aab.png";